export const BASE_URL = (process.env.NODE_ENV === 'development')? 'http://localhost:5000' : 'https://ninjadevbackend.herokuapp.com'

export const INVITE_URL = BASE_URL + '/slack/invite'